import request from 'utils/request'
// 下载模板
export const templateDownload = type =>
  request().get(`customer/file/template/download/${type}`, {
    responseType: 'blob',
  })

//读取导入xlsx表格内容
export const readFile = file => {
  return new Promise(resolve => {
    let reader = new FileReader()
    reader.readAsBinaryString(file)
    reader.onload = ev => {
      resolve(ev.target.result)
    }
  })
}

// 批量导入添加客户账期
export const saveTerm = data => request().post('company/term/add', data)

// 初始化同步S4集团关系接口
export const syncGroup = type => request().post(`sync/syncGroup/${type}`)

// 初始化同步S4账期接口
export const syncPayment = type => request().post(`sync/syncPayment/${type}`)

// 初始化同步S4通用接口
export const syncCurrent = type => request().post(`sync/syncCurrent/${type}`)

// 初始化同步S4专项接口
export const syncSpecial = type => request().post(`sync/syncSpecial/${type}`)

// 查看同步集团关系按钮是否已经初始化过
export const getSyncStatus = syncType =>
  request().get(`sync/getSyncStatus/${syncType}`)

// 查看同步客户账期按钮是否已经初始化过
export const getTermStatus = syncType =>
  request().get(`sync/getTermStatus/${syncType}`)

// 查看同步通用额度按钮是否已经初始化过
export const getCurrentStatus = syncType =>
  request().get(`sync/getCurrentStatus/${syncType}`)

// 查看同步专项额度按钮是否已经初始化过
export const getSpecialStatus = syncType =>
  request().get(`sync/getSpecialStatus/${syncType}`)

/**
 * 下载账期导入模板
 */
export const downloadTemp = () =>
  request().get('bp/batch/term/download', { responseType: 'blob' })

/**
 * 上传账期导入文件
 * @param {*} data
 */
export const uploadBatchFile = data =>
  request().post('bp/batch/upload/term', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

/**
 * 下载专项额度导入模板
 */
export const downloadSpecialTemp = () =>
  request().get('bp/batch/special/download', { responseType: 'blob' })

/**
 * 上传专项额度导入文件
 * @param {*} data
 */
export const uploadBatchSpecialFile = data =>
  request().post('bp/batch/upload/special', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 下载
export const download = () =>
  request().get(`sync/download`, { responseType: 'blob' })
